import AppTitle from '@theme/components/atom/AppTitle'
import NewsletterForm from '@theme/components/shop/NewsletterForm/NewsletterFormLazy'

export default {
  components: {
    AppTitle,
    NewsletterForm,
  },
}
